import { Component } from '@angular/core';

@Component({
  selector: 'app-disk-space',
  templateUrl: './disk-space.component.html',
  styleUrl: './disk-space.component.scss'
})
export class DiskSpaceComponent {

}
